'use strict'

var $ = require('jquery');

function init() {
	var $item = $('.detailSummary');
	var className = 'detailSummary__heading';
	var selector_trigger = '.detailSummary__heading';
	var selector_target = '.detailSummary__content';

	function toggleItem(element) {
		var $element = $(element);
		var isOpen = $element.parent().hasClass('target');

		if (isOpen) {
			$element.parent().removeClass('target');
			$element.next().stop(true).slideUp();
		} else {
			$element.parent().addClass('target');
			$element.next().stop(true).slideDown();
		}
	}
	function toggleItemTargeted() {
		console.log('toggleItemTargeted');
		var id = (window.location.hash).replace(/([\.\:])/, '\\$1');
		var $targetedElement = $item.find(id);

		if ($targetedElement.hasClass(className)) {
			toggleItem($targetedElement.get(0));
		}
	}
	function toggleItemAll() {
		console.log('toggleItemAll');
		if (!window.location.hash) {
			var triggers = $item.find(selector_trigger);
			$item.find(selector_trigger).each(function(id) {
				toggleItem(triggers.get(id));
				console.log(id);
			});
		}
	}
	function setupIcons() {
		var svg = '\
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26" height="26">\
			<path class="svg-path-v" d="M12 5h2v16h-2z"/>\
			<path class="svg-path-h" d="M5 12h16v2H5z"/>\
		</svg>';

		$(selector_trigger).append(svg);
	}
	function setupEventHandlers() {
		$item.on('click', selector_trigger, function (event) {
			event.preventDefault();
			history.replaceState(undefined, undefined, location.pathname + "#" + event.currentTarget.id);
			toggleItem(event.currentTarget);
		});
	}

	if (!$item) {
		return;
	}
	setupIcons();
	setupEventHandlers();
	$item.addClass('js-ready');

	var goo = function () {
		$item.find(selector_trigger).siblings(selector_target).slideUp(0);
		console.log('goo');
	};
	$.when(goo()).done(function () {
		toggleItemTargeted();
		// toggleItemAll();
	});
}
module.exports = {
	init : init
};
